const waitingToSeeRouter = {
  path: "businessArea/waiting-see",
  name: "waiting-see",
  meta: {
    title: "待回看"
  },
  component: () => import("@/pages/index/home/businessArea/Index"),
  children: [
    {
      path: "project",
      name: "waiting-see-project",
      meta: {
        title: "待回看-列表页"
      },
      component: () => import("@/pages/index/home/businessArea/List")
    },
    {
      path: "carrier",
      name: "waiting-see-carrier",
      meta: {
        title: "待回看-列表页"
      },
      component: () => import("@/pages/index/home/businessArea/List")
    }
  ]
};
export default waitingToSeeRouter;



// WEBPACK FOOTER //
// ./src/router/index/waitingToSee/waitingToSee.js